/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Tile_Activate_SubtitleInputs */

const en_home_hero_tile_activate_subtitle = /** @type {(inputs: Home_Hero_Tile_Activate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up your portal in a few minutes`)
};

const fr_home_hero_tile_activate_subtitle = /** @type {(inputs: Home_Hero_Tile_Activate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez votre portail en quelques minutes`)
};

/**
* | output |
* | --- |
* | "Set up your portal in a few minutes" |
*
* @param {Home_Hero_Tile_Activate_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_tile_activate_subtitle = /** @type {((inputs?: Home_Hero_Tile_Activate_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Tile_Activate_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_tile_activate_subtitle(inputs)
	return fr_home_hero_tile_activate_subtitle(inputs)
});